import { ICartCallback, ICartProduct } from "@Utilities/Cart";
import { HeaderBase } from "@Base/Site/HeaderBase";
import axios from "axios";

export class CartService
{
	public AddProduct = (product: ICartProduct, callback?: ICartCallback): Promise<any> =>
	{
		const url = "/product/addproduct";

		return axios.post(url, product)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public RestoreCart = (ogid: string): Promise<any> =>
	{
		const url = "/api/carts/restorecart?ogid=" + ogid;

		return axios.post(url)
			.then((response) =>
			{
				const itemOrderQuantity = response.data;

				if (itemOrderQuantity !== undefined)
				{
					const itemOrderQuantityNumber: number = +itemOrderQuantity;
					const headerBase = new HeaderBase();
					headerBase.UpdateCartIcon(itemOrderQuantityNumber);
				}
			})
			.catch((error) =>
			{
				console.log(error);
			});
	};
}